import { useState, useCallback } from "react";
import useToggle from "./useToggle";
import { useNavigate } from "react-router-dom";

const useDefaultPage = <T>() => {
    const [selectedItem, setSelectedItem] = useState<T | undefined>(undefined)
    const [isOpenDrawer, setIsOpenDrawer, setManualOpenDrawer] = useToggle()
    const [isOpenDialog, setIsOpenDialog, setManualOpenDialog] = useToggle()
    const navigate = useNavigate()

    const onPressEditItem = useCallback((item: T) => {
        setManualOpenDrawer(true)
        setSelectedItem(item)
    },[setManualOpenDrawer, setSelectedItem])

    const onPressAddItem = useCallback(() => {
        setManualOpenDrawer(true)
        setSelectedItem(undefined)
    }, [setManualOpenDrawer, setSelectedItem])

    const onPressDeleteItem = useCallback((item: T) => {
        setManualOpenDialog(true)
        setSelectedItem(item)
    },[setManualOpenDialog, setSelectedItem])

    const reditectTo = useCallback((pathname: string) => {
        navigate({pathname})
    },[navigate])

    const clearSelectedItem = useCallback(() => {
        setSelectedItem(undefined)
    }, [setSelectedItem])

    const onCloseDilog = useCallback(() => {
        setManualOpenDialog(false)
        setSelectedItem(undefined)
    },[setManualOpenDialog, setSelectedItem])

    return {
        selectedItem,
        isOpenDrawer,
        isOpenDialog,
        setIsOpenDrawer,
        onPressAddItem,
        onPressEditItem,
        onPressDeleteItem,
        reditectTo,
        clearSelectedItem,
        setSelectedItem,
        onCloseDilog,
        setIsOpenDialog
    } as  const
}

export default useDefaultPage;